import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './PricesSection.module.scss';

export interface CardData {
  id: number;
  name_ru: string;
  name_en: string;
  flag_url: string;
  day_price: string;
  week_price: string;
  month_price: string;
  points_ru: string[];
  points_en: string[];
}

const geoIcon = 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/icons/geo-alt-fill.svg';
const checkIcon = 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/icons/check-circle-fill.svg';

interface PricesSectionProps {
  onOpenPopup: () => void;
  cards: CardData[];
  loading: boolean;
}

const PricesSection: React.FC<PricesSectionProps> = ({ onOpenPopup, cards, loading }) => {
  const { t, i18n } = useTranslation();
  const [shakeIndex, setShakeIndex] = useState<number | null>(null);

  const isRu = i18n.language.startsWith('ru');

  // Анимация shake для кнопок
  useEffect(() => {
    if (cards.length === 0) return;

    setShakeIndex(Math.floor(Math.random() * cards.length));
    const interval = setInterval(() => {
      setShakeIndex(Math.floor(Math.random() * cards.length));
    }, 3000);
    return () => clearInterval(interval);
  }, [cards]);

  const getName = (card: CardData) => isRu ? card.name_ru : card.name_en;
  const getPoints = (card: CardData) => isRu ? card.points_ru : card.points_en;

  if (loading) {
    return (
      <section className={styles.pricesSection} id="prices">
        <h2 className={styles.title}>{t('prices.title')}</h2>
        <p className={styles.description}>{t('prices.description')}</p>
        <div className={styles.loading}>
          <div className={styles.spinner}></div>
        </div>
      </section>
    );
  }

  return (
    <section className={styles.pricesSection} id="prices">
      <h2 className={styles.title}>{t('prices.title')}</h2>
      <p className={styles.description}>{t('prices.description')}</p>

      {/* Список стран */}
      <ul className={styles.countryList}>
        {cards.map((card) => (
          <li key={card.id}>
            <img src={card.flag_url} alt={getName(card)} loading="lazy" />
            <span>{getName(card)}</span>
          </li>
        ))}
      </ul>

      {/* Сетка карточек */}
      <div className={styles.cardsGrid}>
        {cards.map((card, index) => (
          <div className={styles.card} key={card.id}>
            <div className={styles.cardHeader}>
              <div className={styles.countryInfo}>
                <img src={geoIcon} alt="geo" className={styles.geoIcon} loading="lazy" />
                <h3>{getName(card)}</h3>
              </div>
            </div>

            <div className={styles.pricesRow}>
              <div className={styles.priceItem}>
                <span>{t('prices.day')}</span>
                <strong>{card.day_price}</strong>
              </div>
              <div className={styles.priceItem}>
                <span>{t('prices.week')}</span>
                <strong>{card.week_price}</strong>
              </div>
              <div className={styles.priceItem}>
                <span>{t('prices.month')}</span>
                <strong>{card.month_price}</strong>
              </div>
            </div>

            <ul className={styles.pointsList}>
              {getPoints(card).map((point, i) => (
                <li key={i}>
                  <img src={checkIcon} alt="check" className={styles.checkIcon} loading="lazy" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>

            <button
              className={`${styles.buyButton} ${shakeIndex === index ? styles.shake : ''}`}
              onClick={onOpenPopup}
            >
              {t('prices.buyButton')}
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PricesSection;
